export function getPagecontact ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pagecontact')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCreatePagecontact ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pagecontact/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createPagecontact ({ state, commit }, { contentName, content }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagecontact', { contentName, content })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createPagecontactWarehouse ({ state, commit }, { DEPOZIT, ADRESA, EMAIL, TELEFON }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagecontact/warehouse', { DEPOZIT, ADRESA, EMAIL, TELEFON })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditPagecontact ({ state, commit }, pId) {
  return new Promise((resolve, reject) => {
    if (pId) {
      axiosInstance.get('/v1/pagecontact/' + pId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No page contact id'))
    }
  })
}

export function editPagecontact ({ state, commit }, { id, contentName, content }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/pagecontact/' + id, { id, contentName, content })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No page contact id'))
    }
  })
}

export function editWarehouse ({ state, commit }, { id, DEPOZIT, ADRESA, TELEFON, EMAIL }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/pagecontact/' + id + '/warehouse', { item: { DEPOZIT, ADRESA, TELEFON, EMAIL } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No warehouse id'))
    }
  })
}

export function deleteWarehouse ({ state, commit }, wId) {
  return new Promise((resolve, reject) => {
    if (wId) {
      axiosInstance.delete('/v1/pagecontact/' + wId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No warehouse id'))
    }
  })
}
